import CustomerResponse from "../../../../api/models/customer/Customer.response";
import CountryResponse from "../../../../api/models/country/Country.response";
import DescriptionFormType from "./Description.form";
import parseInteger from "../../../../functions/parseInteger.function";
import formatInteger from "../../../../functions/formatInteger.function";
import UrlParameters from "../../models/UrlParameters.model";
import currencies from "../../../../assets/data/currencies";
import EnumType from "../../../../models/EnumType";
import * as mcgrCgr from "../../../../assets/data/mcgr-cgr.json";
import * as Fields from "../forms/fieldNames";

type OpportunityValueCurrencyCode = TestRequestRaw.Schemas.CurrencyCode;

const stringifiedMcgrCgr = JSON.stringify(mcgrCgr);
const mcgrCgrData = JSON.parse(stringifiedMcgrCgr).default;

function mapMcgr(urlParams: UrlParameters) {
  const cgrDependentValues = {
    mcgr: "",
    cgr: "",
  };
  const listedMcgrs = Object.keys(mcgrCgrData);
  const cgr = urlParams.tesa_cgrid || "";
  listedMcgrs.forEach((listedMcgr) => {
    if (mcgrCgrData[listedMcgr].includes(cgr)) {
      cgrDependentValues.mcgr = listedMcgr;
      cgrDependentValues.cgr = cgr;
    }
  });
  return cgrDependentValues;
}

function mapCurrency(currencyCode: string | undefined) {
  const currency = currencyCode?.toUpperCase() || "";
  return currencies.includes(currency) ? (currency as EnumType<OpportunityValueCurrencyCode>) : "EUR";
}

export default function mapFromUrlParams(
  urlParams: UrlParameters,
  customerResponse: CustomerResponse | null,
  countryResponse: CountryResponse | null,
): DescriptionFormType {
  const cgrDependentValues = mapMcgr(urlParams);
  return {
    [Fields.APPLICATION_FIELD]: "",
    [Fields.PRIORITY]: "NONE",
    [Fields.ASSIGNEE]: null,
    [Fields.BACKGROUND_INFORMATION]: "",
    [Fields.BUSINESS_TYPE]: "",
    [Fields.BUSINESS_UNIT]: "",
    [Fields.CRM_NO]: parseInteger(urlParams.tesa_syncid)?.toString() || "",
    [Fields.CSC_LAB]: "",
    [Fields.SOLUTION]: urlParams.description || "",
    [Fields.CUSTOMER_CLASSIFICATION]: "",
    [Fields.CUSTOMER_PART]: "",
    [Fields.DEADLINE]: urlParams.estimatedclosedate || "",
    [Fields.DEBITOR_NO]: formatInteger(parseInteger(urlParams.tesa_accountnumber)),
    [Fields.DIRECT_CUSTOMER]: customerResponse && {
      id: customerResponse.id || 0,
      name: customerResponse.name || "",
      crmAccountId: customerResponse.crmAccountId || "",
      crmAccountNumber: customerResponse.crmAccountNumber || "",
      country: customerResponse.country || {
        id: undefined,
        name: "",
        crmCountryId: "",
        twoLetterCode: "",
      },
    },
    [Fields.DIRECT_CUSTOMER_CGR]: cgrDependentValues.cgr,
    [Fields.DIRECT_CUSTOMER_LOCATION]: countryResponse && {
      id: countryResponse.id || undefined,
      name: countryResponse.name || "",
      crmCountryId: countryResponse.crmCountryId || "",
      twoLetterCode: countryResponse.twoLetterCode || "",
    },
    [Fields.DISTRIBUTOR]: null,
    [Fields.FINISHING_DATE]: "",
    [Fields.TEST_EFFORT_IN_DAYS]: "",
    [Fields.INTERNAL_CONTACT]: "",
    [Fields.INTERNAL_CONTACTS]: [],
    [Fields.MARKET_SEGMENT]: "",
    [Fields.OEM]: null,
    [Fields.OPPORTUNITY_PRODUCTS]: [],
    [Fields.CURRENCY]: mapCurrency(urlParams.transactioncurrencyid),
    [Fields.PNS]: parseInteger(urlParams.estimatedvalue)?.toString() || "",
    [Fields.PROCESS_DETAIL]: "",
    [Fields.PROCESS_TYPE]: "",
    [Fields.PRODUCTS]: urlParams.tesa_bnrid,
    [Fields.PRODUCT_REFERENCES]: [],
    [Fields.COMPETITOR_PRODUCT_REFERENCES]: [],
    [Fields.PROTOTYPE_PRODUCT_REFERENCES]: [],
    [Fields.CONFIDENTIALITY]: "",
    [Fields.REPORT_LANGUAGE]: "ENGLISH",
    [Fields.REPORT_USAGE]: "ONLY_INTERNAL",
    [Fields.SALES_TEAM]: [],
    [Fields.SPECIFICATION_NEEDED]: false,
    [Fields.SPECIFICATION]: [],
    [Fields.SUBSTRATES]: "",
    [Fields.APPROVER]: null,
    [Fields.TEST_LOCATION]: "CSC_LAB",
    [Fields.TEST_PROGRAM]: "",
    [Fields.TITLE]: "",
    [Fields.TEST_PURPOSE]: "",
    [Fields.EXTERNAL_DEVELOPMENT_BUDGET]: "",
    [Fields.EXTERNAL_DEVELOPMENT_BUDGET_CURRENCY_CODE]: "",
  };
}
